import { nanoidBrowser } from '@naturalcycles/js-lib'
import { apiFetcher } from '@src/srv/api.service'
import { socialMediaMarketingService } from './socialMediaMarketing.service'

interface NewsletterAccountInput {
  email: string
  source?: string
  campaign?: string
  consentTo?: string
}

class NewsletterService {
  async addToNewsletterAccount(input: NewsletterAccountInput): Promise<void> {
    const { email } = input
    void socialMediaMarketingService.lead({ id: nanoidBrowser(), email })

    await apiFetcher.put(`api/v3/newsletteraccount`, {
      json: input,
    })
  }
}

export const newsletterService = new NewsletterService()
